class BundleUpsellBanner extends HTMLElement {
  connectedCallback() {
    try {
      const dataAttr = this.getAttribute("data-bundle") || "{}";
      const data = JSON.parse(dataAttr);
      const { bundle, ui } = data;

      if (!bundle || !bundle.handle || !bundle.drawerId) return;

      this.bundle = bundle;
      this.ui = ui || {};
      this.pendingParentAdd = false;

      this.render();
      this.attachEvents();
    } catch (e) {
      console.error("BundleUpsellBanner init error:", e);
    }
  }

  render() {
    const {
      title,
      image,
      label,
      price_html,
      button_text,
      description,
      banner_title,
      single_price_color,
    } = this.ui;

    const priceCompare =
      this.ui.price_compare ||
      this.ui.price_comapare ||
      this.ui.compare_at ||
      "";
    const hasSinglePriceColor = single_price_color && single_price_color.trim();
    const priceBlock =
      priceCompare && priceCompare.trim()
        ? `<div class="price"><s>${price_html || ""}</s><span class="discounted">${priceCompare}</span></div>`
        : price_html
          ? `<div class="price${hasSinglePriceColor ? " text-subdued" : ""}">${price_html}</div>`
          : "";
    const imgHtml = image
      ? `<img src="${image}" alt="${title || ""}" loading="lazy" width="100%" />`
      : "";
    const styleTag = hasSinglePriceColor
      ? `<style>.bundle-upsell-container .price.text-subdued * { color: ${single_price_color} !important; }</style>`
      : "";

    this.innerHTML = `
        ${styleTag}
        <div class="bundle-upsell-container">
        <h5>${banner_title}</h5>
          <div class="bundle-upsell">
            <div class="left">
              ${imgHtml}
            </div>
            <div class="content">
              <div class="top-content">
                ${label && label.trim() ? `<p class="upgrade badge">${label}</p>` : ""}
                ${priceBlock}
              </div>
              <div class="bottom_content">
                <div class="left-content-banner">
                  ${title ? `<div class="title">${title}</div>` : ""}
                  ${description ? `<div class="description">${description}</div>` : ""}
                </div>
                <button class="bundle-add-btn" aria-controls="${this.bundle.drawerId}" aria-expanded="false" is="custom-button">${button_text || "+ Add"}</button>
              </div>
              </div>
            </div>
          </div>
        </div>`;
  }

  attachEvents() {
    const openBtn = this.querySelector(".bundle-add-btn");
    if (!openBtn) return;

    openBtn.addEventListener("click", () => {
      this.pendingParentAdd = true;
      this.parentAddedForClick = false;
      // The drawer will be opened by existing theme JS via aria-controls
    });

    // After a variant is added via quick buy, also add current parent variant once
    this._onCartRefresh = (evt) => {
      try {
        const baseEvent = evt?.detail?.baseEvent;
        if (!this.pendingParentAdd || this.parentAddedForClick) return;
        if (baseEvent !== "variant:add") return;

        const eventCart = evt?.detail?.cart;
        const bundleInCart = this.isBundleInCart(eventCart);

        if (bundleInCart) {
          this.parentAddedForClick = true;
          this.pendingParentAdd = false;
          this.addParentCurrentVariant();
        } else {
          // Fallback: fetch cart to verify
          this.verifyBundleThenAdd();
        }
      } catch (e) {
        console.error("BundleUpsellBanner cart:refresh handler error:", e);
      }
    };

    document.documentElement.addEventListener(
      "cart:refresh",
      this._onCartRefresh,
    );
  }

  disconnectedCallback() {
    if (this._onCartRefresh) {
      document.documentElement.removeEventListener(
        "cart:refresh",
        this._onCartRefresh,
      );
    }
  }

  isBundleInCart(cart) {
    try {
      if (!cart || !cart.items) return false;
      return cart.items.some((item) => item.handle === this.bundle.handle);
    } catch (_) {
      return false;
    }
  }

  async verifyBundleThenAdd() {
    try {
      const res = await fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const cart = await res.json();
      if (this.isBundleInCart(cart) && !this.parentAddedForClick) {
        this.parentAddedForClick = true;
        this.pendingParentAdd = false;
        await this.addParentCurrentVariant();
      }
    } catch (e) {
      console.error("verifyBundleThenAdd error:", e);
    }
  }

  async addParentCurrentVariant() {
    try {
      const formReference = document
        .querySelector("variant-picker")
        ?.getAttribute("form");
      if (!formReference) return;
      const form = document.getElementById(formReference);
      if (!form) return;
      const currentId = form.elements["id"]?.value;
      if (!currentId) return;

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: currentId, quantity: 1 }],
          sections:
            "cart-count, variant-added, sections--17218834694186__cart-drawer",
        }),
      });

      if (!response.ok) throw new Error("Failed to add parent product");

      const cart = await fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const cart_data = await cart.json();

      document.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: { baseEvent: "line-item:change", cart: cart_data },
        }),
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { baseEvent: "variant:add", cart: cart_data },
        }),
      );

      const cartDrawerButton = document.querySelector(
        '[aria-controls="cart-drawer"]',
      );
      if (cartDrawerButton) cartDrawerButton.click();
    } catch (error) {
      console.error("Error adding parent product:", error);
    }
  }
}

customElements.define("bundle-upsell-banner", BundleUpsellBanner);
